import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Button } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'

class DeviceGroupErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError (error) {
    return { hasError: true, error }
  }

  componentDidCatch (error, errorInfo) {
    console.error('DeviceGroupWidget Error:', error, errorInfo)
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null })
    if (this.props.onRetry) {
      this.props.onRetry()
    }
  }

  render () {
    if (this.state.hasError) {
      const { t_ } = this.props
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            p: 2,
            textAlign: 'center',
            color: 'error.main'
          }}
        >
          <WarningIcon sx={{ fontSize: 48, mb: 2 }} />
          <Typography variant='h6' gutterBottom>
            {t_ ? t_('Something went wrong') : 'Something went wrong'}
          </Typography>
          <Typography variant='body2' sx={{ mb: 2, maxWidth: 400 }}>
            {this.state.error?.message || (t_ ? t_('An unexpected error occurred in the device group widget.') : 'An unexpected error occurred.')}
          </Typography>
          <Button variant='outlined' color='error' onClick={this.handleRetry}>
            {t_ ? t_('Retry') : 'Retry'}
          </Button>
        </Box>
      )
    }

    return this.props.children
  }
}

DeviceGroupErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  t_: PropTypes.func,
  onRetry: PropTypes.func
}

export default DeviceGroupErrorBoundary
